// extracted by mini-css-extract-plugin
module.exports = {"info":"Top5Rank_info__2G5Dj","all":"Top5Rank_all__1_Lmm","container":"Top5Rank_container__14pGp","nro":"Top5Rank_nro__2Llpd","nick":"Top5Rank_nick__1n2MP"};